import i18n from '@dms/i18n';

import {useVehicleFormContext} from '../hooks/useVehicleFormContext';
import {Field} from './primitives/Field';

export function SeatCountChips() {
  const {catalogueApi} = useVehicleFormContext();
  return (
    <Field
      type="chips"
      name="seatCount"
      options={catalogueApi?.seatCountOptions ?? []}
      label={i18n.t('entity.vehicle.labels.numberOfSeatsFull')}
      isDeselectable
    />
  );
}
